import styled from "styled-components";
import Table from "../Table";

export const LeagueSummaryTable = styled(Table)`
  table-layout: fixed;
  margin-bottom: ${({ theme }) => theme.space[3]};
`;
